import React from "react";

let API = "{host}/api/v1/get-glyph";
const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;

const checkKind = (id) => {
  // Si no se proporciona un sufijo (kind), establecer el valor por defecto como "m"
  if (!id.includes("-")) {
    id += "-m";
  }
  const words = id.split("-");
  const validKinds = ["s", "m", "l"];
  const suffix = words.pop();
  if (validKinds.includes(suffix)) {
    return id;
  } else {
    return id+'-m';
  }
}

const IconGlyph = (props) => {
  let { id, color, className, priority, kind } = props;
  const finalId = kind ? `${id}-${kind}`: checkKind(id)
  let { width, height, insetPosition, dataCy } = props;
  if(!dataCy){
    dataCy = `${id}`
  }

  // para el div de fuera
  const size = {
    width: width || 'auto',
    height: height || 'auto',
  };


  if (currentEnv !== 'prod') {
    // API = API.replace('{host}', 'https://dev.ssr.col.movistar.es');
    API = API.replace('{host}', 'https://ssr.col.movistar.es');
  } else {
    API = API.replace('{host}', 'https://ssr.col.movistar.es');
  }


  /* damos valor a la otra coordenada en caso de no indicarse */
  if (size.height !== 'auto' && size.width === 'auto') {
    size.width = height;
  }

  if (size.width !== "auto" && size.height === 'auto') {
    size.height = width;
  }

  let loadingAttribute = 'eager';
  let fetchPriorityAttribute = 'high';
  if(!priority){
    loadingAttribute = 'lazy';
    fetchPriorityAttribute = 'none'
  }

  let finalClassName = 'svg-layout-size'
  if (className) {
    finalClassName = `${finalClassName} ${className}`;
  }

  return (
    <div className={finalClassName} style={size}>
      <img
        data-cy={dataCy}
        src={`${API}/${finalId}/${height}/${color}`}
        style={{ 
          insetPosition,
          width: '100%',
          height: height ? "100%" : "auto"
        }}
        loading={loadingAttribute}
        fetchpriority={fetchPriorityAttribute}
      />
    </div>
  );
};
export default IconGlyph;